var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-field-like',_vm._b({},'text-field-like',_vm.$props,false),[_c('hds-id-box',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }